import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'src/containers/_loading';
import { ThePermission } from '../ThePermission';
import { helps } from 'src/_helpers';
import { docActions, fileActions } from 'src/_actions';
import DocForm from 'src/views/docs/DocForm';


class DocsFormContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            doc: {},
            form_header: "Thêm Văn Bản",
            action_status: 'add',
        }

        this.handleUpload = this.handleUpload.bind(this);
    }

    componentDidMount() {
        this.getCategories();
        this.getDocs().then(() => {
            this.getDoc();
        });
    }

    getDoc() {
        let doc_id = this.props.match.params.id;
        const docs = this.props.docs;
        if (doc_id) {
            let doc = helps.getItemFromArr(docs, doc_id);
            this.setState({ form_header: "Chỉnh Sửa Thông Tin Văn Bản: " + doc.title, action_status: 'edit', doc: doc });
        }
    }

    async getDocs() {
        const docs = this.props.docs;
        if (helps.isEmpty(docs)) await this.props.getAll();
    }

    async getCategories() {
        if (helps.isEmpty(this.props.categories)) return await this.props.getAllCat();
    }

    handleSubmit = (doc, upload_files) => {
        let doc_id = this.props.match.params.id;
        var url = '/docs';
        if (helps.isEmpty(doc_id)) {
            this.props.add(doc);
        } else {
            this.props.update(doc);
        }
        this.handleUpload(doc, upload_files);
        this.props.history.push(url);
    }

    handleUpload(doc, upload_files) {
        const { user } = this.props;

        if (!helps.isEmpty(upload_files) && upload_files.length > 0) {
            const object = 'docs';
            const object_id = doc.year ? doc.year : new Date().getFullYear();
            this.props.uploadDocs(doc, upload_files, object, object_id.toString(), user);
        }
    }

    render() {
        if (this.props.loading) {
            return (
                <Loading></Loading>
            );
        }
        let doc_id = this.props.match.params.id;
        const { doc } = this.state;
        if (!helps.isEmpty(doc_id) && helps.isEmpty(doc)) return (<Loading></Loading>);

        return (
            <ThePermission {... this.props} component="docs" action="edit">
                <DocForm
                    {... this.props}
                    doc={this.state.doc}
                    form_header={this.state.form_header}
                    action_status={this.state.action_status}
                    handleSubmit={this.handleSubmit}
                />
            </ThePermission>
        );
    }
}
function mapStateToProps(state) {
    const { loading, docs, categories } = state.docsReducer;
    const { user } = state.authentication;
    const { employees } = state.employeeReducer;
    const { customers } = state.customerReducer;
    const { housings } = state.housingReducer;
    const { vendors } = state.vendorReducer;
    const { projects } = state.projectReducer;
    return { loading, docs, categories, user, employees, customers, housings, vendors, projects };
}

const actionCreators = {
    getAll: docActions.getAll,
    add: docActions.add,
    update: docActions.update,
    getAllCat: docActions.getAllCat,
    uploadDocs: docActions.uploadDocs,
};
const connectedFormContainer = connect(mapStateToProps, actionCreators)(DocsFormContainer);
export { connectedFormContainer as DocsFormContainer };